export default __webpack_public_path__ + "static/demand360-product-7e456a57559645736da556fbc3ee15cc.jpg";